import {Link} from "react-router-dom";

import sdk from "scoutli-sdk"

import logo from "../../assets/logo.png"
import {useRef, useState} from "react";

const ForgotPassword = () => {
    const [type, setType] = useState(null)

    const email = useRef("")

    return (
        <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <Link to="/">
                    <img
                        className="mx-auto h-12 w-auto"
                        src={logo}
                        alt="Scoutli"
                    />
                </Link>

                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset your password</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 sm:rounded-lg sm:px-10">
                    <form className="space-y-6" action="#" method="POST" onSubmit={event => {
                        event.preventDefault()

                        sdk.passwordreset.sendUserLink(email.current.value).then(() => {
                            setType(0)
                        }).catch(() => {
                            setType(1)
                        })
                    }}>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                Email address
                            </label>

                            <div className="mt-1">
                                <input
                                    ref={email}
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 transition-colors rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        {type === 0 && (
                            <p className="mt-2 text-green-400 text-sm">Password reset link successfully sent.</p>
                        )}

                        {type === 1 && (
                            <p className="mt-2 text-red-400 text-sm">Email not found.</p>
                        )}

                        <div>
                            <button
                                disabled={type !== null}
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white bg-brand transition-colors hover:bg-indigo-600"
                            >
                                Send reset email
                            </button>
                        </div>

                        <div className="text-sm text-center">
                            <Link to="/login"
                                  className="font-medium text-indigo-600 transition-colors focus:outline-none hover:text-indigo-500">
                                Cancel and return
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword;
